/* =================
 * MEDIA IMAGES
 * Lazy load and Aspect Ratios preprocessing
 * =================
 */

import { map } from "underscore";


export class MediaImage {
    images;
    list = [];

    style = document.createElement('style');
    head = document.head || document.getElementsByTagName('head')[0];

    constructor() {
        this.head.appendChild(this.style);

        this.init();
    }

    init() {
        const $images = this.process();

        const lazyImages = $images.filter("img.photo").not(".loading, .loaded, .slide img.photo");
        if (!lazyImages.length) {
            return;
        }

        lazyImages.unveil(200, function() {
            $(this).addClass("loading");
            MediaImage.resolveImage(this).done((img) => {
                $(img).addClass("loaded").removeClass("loading");
                img.onerror = MediaImage.erroredImg(img);
            }).fail(MediaImage.erroredImg(this));
        });

        setTimeout(() => {
            $(window).trigger("lookup");
        }, 2000);

        return lazyImages;
    }

    // errored image callback
    static erroredImg(img) {
        return (e) => {
            const imgErrored = img && $(img) || $(e.target);
            imgErrored.addClass("errored");
        };
    }

    process(){
        let $images = $(this);

        this.images = document.images;

        let nth;
        let len = this.images.length;
        for (nth = 0; nth < len; nth++) {
            let  img  = this.images[nth],
                $img  = $(img),
                $wrap = $($img).closest(".media-image");

            if (!$wrap.length) {
                continue;
            }

            $images = $images.add($img);

            if ($wrap.attr("class").match(/r\d+-\d+/)) {
                continue;
            }

            let w = ($img.attr("width")  || "").replace(/[^-\d\.]/g, ''),
                h = ($img.attr("height") || "").replace(/[^-\d\.]/g, '');

            if (!w || !h) {
                continue;
            }

            let aspect = this.add(w, h);
            $wrap.addClass(aspect);
        }

        this.applyStyles();

        return $images;
    }

    getProportionTerms(w, h) {
        const r = (w / h);
        const n = (r * 10) - r;
        const a = Math.round(n);
        const b = Math.round(n / r);
        const f = (function gcd(a, b) {
            return (b === 0) ? a : gcd(b, a % b);
        }(a, b));

        return [(a / f), (b / f)].join("-").replace(/^/, "r");
    }

    getVerticalRatio(w, h, ar) {
        let vr = ((h / w) * 100).toFixed(2);

        if (ar) {
            ar = ar.replace("r", "").split("-");
            w = ar[0];
            h = ar[1];

            const _vr = ((h / w) * 100).toFixed(2);
            if (parseInt(_vr) === parseInt(vr)) {
                vr = _vr;
            }
        }
        return vr.concat("%");
    }

    add(w, h) {
        const ar = this.getProportionTerms(w, h);
        const vr = this.getVerticalRatio(w, h, ar);

        let aspect = ar;
        let count = 1;

        for (let i = 0, l = this.list.length; i < l; i++) {
            const val = this.list[i];
            if (val.match(ar)) {
                count++;
                if (!val.match(vr)) {
                    aspect = ar + "x" + count;
                }
            }
        }

        const format = [aspect, vr].join("_");
        if (this.list.indexOf(format) === -1) {
            this.list.push(format);
        }

        return aspect;
    }

    applyStyles() {
        const css = map(this.list, (f) => {

            f = f.split("_");
            const ar = f[0];
            const vr = f[1];

            return [
                '.' + ar + ',',
                '.' + ar + ' img.loading,',
                '.' + ar + ' img[src^="data:image"] {padding-top:' + vr + ';}',
                '.' + ar + ' img.loading,',
                '.' + ar + ' img[src^="data:image"] {height:0; overflow:hidden;}',
                '.' + ar + ' img {margin-top: -' + vr + ';}'
            ].join('');
        });

        if (this.style.styleSheet) {
            this.style.styleSheet.cssText = css.join('');
        } else {
            while (this.style.firstChild) {
                this.style.removeChild(this.style.firstChild);
            }
            this.style.appendChild(document.createTextNode(css.join('')));
        }
    }

    static resolveImage(img, src, d, onerror) {
        const defer = d || $.Deferred();

        img.onerror = onerror || function(e) {
            defer.reject(e);
        };

        if (defer.state() === "rejected") {
            return;
        }

        if (!img.complete || typeof img.naturalWidth !== "undefined" && img.naturalWidth === 0) {
            setTimeout(() => {
                MediaImage.resolveImage(img, null, defer, img.onerror);
            }, 250);

            !img.src && (img.src = src);

            return defer.promise();
        }

        return defer.resolve(img);
    }
}
